import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

class MonitorImage extends Component {
  state = {
    imageId: '',
    imageFullUrl: null,
    imagePreviewFullUrl: null,
    showPreview: false,
    showControls: true,
    needsCentering: false,
    centeringText: 'Center',
    fishy: false,
    fishyText: 'Fishy',
    deleteImg: false,
    deleteText: 'Delete',
  };

  // TODO Should be tested if/when this will be used
  constructor(props) {
    super(props);

    this.showPreview = this.showPreview.bind(this);
    this.hidePreview = this.hidePreview.bind(this);

    this.needsCentering = this.needsCentering.bind(this);
    this.needsCenteringText = this.needsCenteringText.bind(this);
    this.cancelCentering = this.cancelCentering.bind(this);
    this.cancelCenteringText = this.cancelCenteringText.bind(this);

    this.addFishy = this.addFishy.bind(this);
    this.addFishyText = this.addFishyText.bind(this);
    this.cancelFishy = this.cancelFishy.bind(this);
    this.cancelFishyText = this.cancelFishyText.bind(this);

    this.deleteImg = this.deleteImg.bind(this);
    this.deleteText = this.deleteText.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.cancelDeleteText = this.cancelDeleteText.bind(this);
  }

  // TODO Should be tested if/when this will be used
  componenDidMount() {
    const {
      imageId,
      filename,
      imageUrlBase,
      imagePreviewUrlBase,
    } = this.props;
    let imageFullUrl = null;
    let imagePreviewFullUrl = null;

    if (filename && imageId) {
      imageFullUrl = imageUrlBase + filename;
      imagePreviewFullUrl = imagePreviewUrlBase + filename;
    }

    this.setState({
      imageId,
      imageFullUrl,
      imagePreviewFullUrl,
    });
  }

  showPreview() {
    this.setState({ showPreview: true });
  }

  hidePreview() {
    this.setState({ showPreview: false });
  }

  needsCentering(e) {
    e.preventDefault();

    const { changeContent } = this.props;
    const { imageId } = this.state;
    changeContent(imageId, 'needs_centering');

    this.setState({
      needsCentering: true,
      showControls: false,
      centeringText: 'Center',
    });
  }

  needsCenteringText() {
    this.setState({ centeringText: 'Center' });
  }

  cancelCentering() {
    const { changeContent } = this.props;
    const { imageId } = this.state;
    changeContent(imageId, 'approved');

    this.setState({
      needsCentering: false,
      showControls: true,
    });
  }

  cancelCenteringText() {
    this.setState({ centeringText: 'Cancel Center' });
  }

  addFishy(e) {
    e.preventDefault();

    const { changeContent } = this.props;
    const { imageId } = this.state;
    changeContent(imageId, 'fishy');

    this.setState({
      fishy: true,
      showControls: false,
      fishyText: 'Fishy',
    });
  }

  addFishyText() {
    this.setState({ fishyText: 'Fishy' });
  }

  cancelFishy() {
    const { changeContent } = this.props;
    const { imageId } = this.state;
    changeContent(imageId, 'approved');

    this.setState({
      fishy: false,
      showControls: true,
    });
  }

  cancelFishyText() {
    this.setState({ fishyText: 'Cancel Fishy' });
  }

  deleteImg(e) {
    e.preventDefault();

    const { changeContent } = this.props;
    const { imageId } = this.state;
    changeContent(imageId, 'abuse');

    this.setState({
      deleteImg: true,
      showControls: false,
      deleteText: 'Delete',
    });
  }

  deleteText() {
    this.setState({ deleteText: 'Delete' });
  }

  cancelDelete() {
    const { changeContent } = this.props;
    const { imageId } = this.state;
    changeContent(imageId, 'approved');

    this.setState({
      deleteImg: false,
      showControls: true,
    });
  }

  cancelDeleteText() {
    this.setState({ deleteText: 'Cancel Delete' });
  }

  render() {
    const {
      showPreview,
      centeringText,
      fishyText,
      deleteText,
      needsCentering,
      fishy,
      deleteImg,
      showControls,
      imageFullUrl,
      imagePreviewFullUrl,
    } = this.state;

    let imageLabelMessage = '';
    if (needsCentering) {
      imageLabelMessage = (
        <button
          type="button"
          className="imagesThumb-label imagesThumb-label-center"
          onClick={this.cancelCentering}
          onMouseEnter={this.cancelCenteringText}
          onMouseLeave={this.needsCenteringText}
        >
          <p>{centeringText}</p>
        </button>
      );
    } else if (fishy) {
      imageLabelMessage = (
        <button
          type="button"
          className="imagesThumb-label imagesThumb-label-fishy"
          onClick={this.cancelFishy}
          onMouseEnter={this.cancelFishyText}
          onMouseLeave={this.addFishyText}
        >
          <p>{fishyText}</p>
        </button>
      );
    } else if (deleteImg) {
      imageLabelMessage = (
        <button
          type="button"
          className="imagesThumb-label imagesThumb-label-delete"
          onClick={this.cancelDelete}
          onMouseEnter={this.cancelDeleteText}
          onMouseLeave={this.deleteText}
        >
          <p>{deleteText}</p>
        </button>
      );
    }

    let controllButtons = '';
    if (showControls) {
      controllButtons = (
        <div>
          <a href="/" onClick={this.addFishy} className="btn btn--danger btn--small admin-imageFishyBtn admin-imageFishyBtn-moreToTop">F</a>
          <a href="/" onClick={this.deleteImg} className="btn btn--danger btn--small admin-imageAbuseBtn admin-imageAbuseBtn--moreRight">D</a>
          <a href="/" onClick={this.needsCentering} className="btn btn--b btn--small admin-imageCenterBtn crop-image">C</a>
        </div>
      );
    }

    const readyImage = (
      <div className="admin-monitorImage">
        <div className="imagesThumb">
          <div className="imagesThumb-image" onMouseEnter={this.showPreview} onMouseLeave={this.hidePreview}>
            <a href="/">
              <img className="admin-monitorImage-thumbnail" src={imageFullUrl} alt="" />
            </a>
            <CSSTransition
              in={showPreview}
              timeout={500}
              classNames="adminMonitorImageShowPreview"
              unmountOnExit
            >
              <a href="/"><img className="admin-monitorImage-preview" src={imagePreviewFullUrl} alt="" /></a>
            </CSSTransition>
            { imageLabelMessage }
          </div>
          { controllButtons }
        </div>
      </div>
    );

    return readyImage;
  }
}

MonitorImage.propTypes = {
  filename: PropTypes.string.isRequired,
  imageId: PropTypes.string.isRequired,
  changeContent: PropTypes.func.isRequired,
  imageUrlBase: PropTypes.string.isRequired,
  imagePreviewUrlBase: PropTypes.string.isRequired,
};

export default MonitorImage;
